"use client";

import React, { useState } from "react";
import "./ButtonAnimated.css";
import ChevronRight from "@/assets/svgs/ChevronRight";
import Link from "next/link";

function ButtonAnimated({
  onClick, // Standard onClick handler
  text = "Auto Bewerten",
  width = "200px",
  height = "52px",
  borderColor = "transparent",
  backgroundColor = "#085fcc",
  hoverBackgroundColor = "#2c70d2",
  hoverBorderColor = "transparent",
  color = "#fff",
  hoverColor = "#fff",
  fontSize = "16px",
  className,
  hideChevron,
  hideMaxWidth,
  link,
  disabled,
  reversed = false,
  removPadding = false,
  maxWidth = "266px",
}) {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const buttonStyle = {
    width: width || "100%",
    height,
    minWidth: width,
    border: `2px solid ${isHovered ? hoverBorderColor : borderColor}`,
    backgroundColor: isHovered ? hoverBackgroundColor : backgroundColor,
    color: isHovered ? hoverColor : color,
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.3s ease",
    maxWidth: hideMaxWidth ? "unset" : maxWidth,
    opacity: disabled ? "0.4" : "1",
    padding: removPadding ? "0px" : "0px 12px",
  };

  const textStyle = {
    color: isHovered ? hoverColor : color,
    transition: "all 0.3s ease",
    fontSize,
  };

  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  const renderButtonContent = () => (
    <>
      {reversed ? (
        <>
          {!hideChevron && (
            <ChevronRight
              className="Button-Animated-Chevron reversed"
              width={28}
              height={28}
            />
          )}
          <span style={textStyle}>{text}</span>
        </>
      ) : (
        <>
          <span style={textStyle}>{text}</span>
          {!hideChevron && (
            <ChevronRight
              className="Button-Animated-Chevron"
              width={28}
              height={28}
            />
          )}
        </>
      )}
    </>
  );

  return (
    <>
      {link ? (
        <Link
          href={link}
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <button
            style={buttonStyle}
            className={`${className} Button-Animated-Button`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleClick}
          >
            {renderButtonContent()}
          </button>
        </Link>
      ) : (
        <button
          style={buttonStyle}
          disabled={disabled}
          className={`${className} Button-Animated-Button`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={handleClick}
        >
          {renderButtonContent()}
        </button>
      )}
    </>
  );
}

export default ButtonAnimated;
